export function initializeDataLayer(accessToken: string) {
  (window as any).dataLayer = (window as any).dataLayer || [];
	(window as any).dataLayer.push({
    coveo_token: accessToken,
  });
  (window as any).dataLayer.push({
    event: 'coveo_token_ready',
  });
}